import React, { Fragment } from 'react'
import actions from 'redux/actions'
import { useConnect } from 'sb-redux-hook'
import { constants, snowplow } from 'common/helpers'
import { injectIntl } from 'sb-react-intl'

import SidebarNav from './SidebarNav/SidebarNav'

import messages from './messages'
import s from './HamburgerButton.scss'


const HamburgerButton = ({ intl }) => {
  const { userLoggedIn } = useConnect({
    userLoggedIn: 'models.me.isLoggedIn',
  })

  return (
    <Fragment>
      <button
        className={s.button}
        aria-label={intl.formatMessage(messages.mainMenu)}
        type="button"
        onClick={() => {
          actions.models.ui.openSideMenu()
          snowplow.track(constants.snowplowEvents.burgerMenuClick, {
            userLoggedIn: userLoggedIn ? 'yes' : 'no',
          })
        }}
      >
        <div className={s.hamburgerIcon} />
      </button>
      <SidebarNav />
    </Fragment>
  )
}


export default injectIntl(HamburgerButton)
